import { colors } from '@alixpartners/ui-components';

export const FONTSTYLE = {
	fontSize: '11px',
	fontWeight: '400',
	lineHeight: '13px',
	letterSpacing: 0,
	color: colors.grey7,
};

export const CHART_COLORS = [
	colors.chartDarkBlue,
	colors.chartBrightTeal,
	colors.chartMediumGrey,
	colors.chartOrange,
	colors.chartDarkGreen,
	colors.chartDarkTeal,
	colors.chartLightBlue,
	colors.chartDarkGrey,
	colors.chartLightOrange,
	'#43AD80',
];

export const VENDORS_BY_CATEGORY_FILTER_DATA = {
	options: [
		{ label: 'All', value: '' },
		{ label: 'WBE', value: 'WBE' },
		{ label: 'MBE', value: 'MBE' },
		{ label: 'SBE', value: 'SBE' },
		{ label: 'VBE', value: 'VBE' },
		{ label: 'Other', value: 'Other' },
	],
	selected: { label: 'All', value: '' },
};

export const USA_HEATMAP_FILTER_DATA = {
	options: [
		{ label: 'WBE', value: 'WBE' },
		{ label: 'MBE', value: 'MBE' },
		{ label: 'SBE', value: 'SBE' },
		{ label: 'VBE', value: 'VBE' },
		{ label: 'Other', value: 'Other' },
	],
	selected: [],
};

export const MULTIPLE_DIVERSITY_FILTER_DATA = {
	options: [
		{ label: 'All', value: 0 },
		{ label: '1', value: 1 },
		{ label: '2', value: 2 },
		{ label: '3', value: 3 },
		{ label: '4', value: 4 },
	],
	selected: { label: 'All', value: 0 },
};

export const CheckPositiveValues = obj => {
	const result = {};
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			result[key] = typeof obj[key] === 'number' && obj[key] > 0 ? obj[key] : 0;
		}
	}
	return result;
};
